module.exports = __webpack_public_path__ + "static/media/logo-info.133fa36d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-info.png
// module id = 576
// module chunks = 0